module.exports = __webpack_public_path__ + "img/timer-icon.18b0bfb8.svg";